import React, { useContext, useEffect, useMemo, useState } from "react";
import {
  Box,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import axios from "../../api/axios";
import { PreferencesContext } from "../../context/PreferencesContext";
import { AuthContext } from "../../context/AuthContext";
import ItemDashboard from "../../components/reports/ItemDashboard";

export default function ItemDashboardPage() {
  const { organization, academicYear } = useContext(PreferencesContext);
  const { user } = useContext(AuthContext);

  const [branches, setBranches] = useState([]);
  const [grades, setGrades] = useState([]);
  const [filters, setFilters] = useState({
    branchIds: [],
    grade: "",
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!organization) return;

    axios.get(`/branches?orgId=${organization}`).then((res) => {
      let list = res.data || [];
      if (user?.role === "branch_manager") {
        list = list.filter((b) =>
          (user.branches || []).some((ub) => String(ub) === String(b._id))
        );
      }
      setBranches(list);
      if (list.length === 1) {
        setFilters((prev) => ({ ...prev, branchIds: [list[0]._id] }));
      }
    });

    axios.get(`/masters/${organization}`).then((res) => {
      setGrades(res.data?.grades || []);
    });
  }, [organization, user]);

  useEffect(() => {
    if (organization && academicYear) {
      setFilters((prev) => ({ ...prev, academicYear }));
      setLoading(false);
    }
  }, [organization, academicYear]);

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const allFilters = useMemo(
    () => ({ orgId: organization, academicYear: academicYear, ...filters }),
    [organization, academicYear, filters]
  );

  if (loading) return <CircularProgress />;

  return (
    <Box p={2}>
      <Typography variant="h5" gutterBottom sx={{ mb: 2 }}>
        Item Purchase Coverage (Books)
      </Typography>

      <Box display="flex" gap={2} flexWrap="wrap" mb={3}>
        {branches.length > 1 && (
          <FormControl sx={{ minWidth: 220 }}>
            <InputLabel>Branch</InputLabel>
            <Select
              label="Branch"
              value={filters.branchIds[0] || ""}
              onChange={(e) =>
                handleFilterChange("branchIds", [e.target.value])
              }
            >
              {branches.map((b) => (
                <MenuItem key={b._id} value={b._id}>
                  {b.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        <FormControl sx={{ minWidth: 160 }}>
          <InputLabel>Grade</InputLabel>
          <Select
            label="Grade"
            value={filters.grade}
            onChange={(e) => handleFilterChange("grade", e.target.value)}
          >
            <MenuItem key={"All"} value={""}>
              All
            </MenuItem>
            {grades.map((g) => (
              <MenuItem key={g} value={g}>
                {g}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <ItemDashboard filters={allFilters} branches={branches} />
    </Box>
  );
}
